import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnInit
} from '@angular/core';

import { IrisIconButtonTypes } from '@sondermind/iris/icon-button';

import { IrisBaseModalComponent } from './base-modal/base-modal.component';
import { IrisModalRef } from './utilities/modal-ref';

@Component({
  selector: 'iris-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class IrisModalComponent<TContent, TModalInputs, TResponseData>
  extends IrisBaseModalComponent<TContent, TModalInputs, TResponseData>
  implements OnInit, AfterViewInit {
  title: string = '';
  showHeader: boolean = true;
  isDismissable: boolean = true;
  closeOnBackdropClick: boolean = false;

  irisIconButtonTypes = IrisIconButtonTypes;

  @HostBinding('style')
  get customStyles(): Record<string, string> {
    return this.ref.config.customStyles ?? {};
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(
    focusTrapFactory: ConfigurableFocusTrapFactory,
    hostElement: ElementRef,
    ref: IrisModalRef<TContent, TModalInputs, TResponseData>
  ) {
    super(focusTrapFactory, hostElement, ref);
  }

  ngOnInit(): void {
    this.title = this.ref.config.title ?? '';
    this.showHeader = this.ref.config.showHeader ?? true;
    this.isDismissable = this.ref.config.isDismissable ?? true;
    this.closeOnBackdropClick = this.ref.config.closeOnBackdropClick ?? false;

    this.initializeModalContent();
  }

  @HostListener('document:keyup.escape', ['$event'])
  private escKeyPressed(): void {
    if (this.isDismissable || this.closeOnBackdropClick) {
      this.close();
    }
  }

  @HostListener('document:click', ['$event'])
  private onBackdropClick(event: Event): void {
    if (this.closeOnBackdropClick) {
      const target = event.target as HTMLElement;
      // Close dropdown if click is outside the component
      if (!this.hostElement.nativeElement.contains(target)) {
        this.close();
      }
    }
  }

  close(): void {
    this.ref.close();
  }
}
